import { z } from 'zod';
import { splitGS1String } from '@allurion/utils';

const ParsedBalloonQRCodeSchema = z.object({
  manufacturingLotNumber: z.string().nonempty(),
  manufacturingDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid manufacturing date format'),
  expirationDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid expiration date format'),
  serialNumber: z.string().nullable(),
});

export type ParsedBalloonQRCode = z.infer<typeof ParsedBalloonQRCodeSchema>;

const ParsedGS1BarcodeSchema = z.string().transform(splitGS1String);
const toParsedBalloonQRCodeSchema = ParsedGS1BarcodeSchema.transform((barcode) => {
  return ParsedBalloonQRCodeSchema.parse({
    manufacturingLotNumber: barcode['BATCH/LOT'],
    manufacturingDate: barcode['PROD DATE'],
    expirationDate: barcode['DUE DATE'],
    serialNumber: barcode['SERIAL'] ?? null,
  });
});

export function parseBalloonQrCode(decodedText: string): ParsedBalloonQRCode | false {
  try {
    const parsed = toParsedBalloonQRCodeSchema.parse(decodedText);
    return parsed;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false;
  }
}
